var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7566 39.36H28.0105C28.0105 39.36 24.6316 31.6745 25.4909 24.6237C26.3503 17.5729 31.9167 14.36 35.071 14.0182C38.2253 13.6764 39.9441 15.6198 39.9441 15.6198L40.6277 14.5846C40.6277 14.5846 36.0964 9.9948 30.364 10.5124C24.6316 11.03 20.6765 14.8093 18.2058 19.3991C15.7449 23.9889 14.3093 27.2018 13.3327 32.0163C12.3562 36.8405 12.7566 39.36 12.7566 39.36Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71948 31.6743L12.698 31.8989L12.1804 34.8774L9.36792 34.5356L9.71948 31.6743Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 25.3657L15.2175 23.1294L12.5808 22.0942L11.7214 24.5064L14.4167 25.3657Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1472 17.6899L19.7 15.854L17.698 14.5356L16.0867 16.313L18.1472 17.6899Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2195 10.5806L23.5964 12.2407L25.491 11.147L24.114 9.59424L22.2195 10.5806Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9285 8.68604L29.2703 10.3462L31.6238 10.2876L31.3894 8.79345L28.9285 8.68604Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8972 10.4634L36.8386 11.4985L38.4402 12.3579L38.782 11.8403L36.8972 10.4634Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5554 14.8774V15.7368L38.1082 15.9126V15.229L36.5554 14.8774Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 15.6196L32.366 16.9966L33.4597 16.1372L33.2351 15.2192L31.6238 15.6196Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2703 17.397L30.4128 19.1157L29.7292 20.3169L28.0691 18.481L29.2703 17.397Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9753 22.1626L26.2332 23.6567L28.1863 25.3169L28.6453 23.4224L26.9753 22.1626Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1746 27.3774L26.0574 29.3794L28.4695 30.4145L28.3523 28.52L26.1746 27.3774Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8679 34.4868L27.4441 36.5474L30.4812 36.7231L29.3874 34.4868H26.8679Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRails);
export default __webpack_public_path__ + "static/media/rails.b9f5625345c952009be3070026755da4.svg";
export { ForwardRef as ReactComponent };